export type CmButtonPalette = 'primary' | 'secondary' | 'warn' | 'gray' | 'composite';

